import { render, staticRenderFns } from "./welcome-sys-admins-only.vue?vue&type=template&id=c7f6af22&scoped=true&"
import script from "./welcome-sys-admins-only.vue?vue&type=script&lang=js&"
export * from "./welcome-sys-admins-only.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f6af22",
  null
  
)

export default component.exports